import React from 'react'
import {
  IonSkeletonText
} from '@ionic/react'
import './styles.scss'

const EditorCard = () => {
  return (
    <section className='editor-card'>
      <div className='wrapper'>
        <IonSkeletonText className='picture' animated />
        <IonSkeletonText className='editor-name' animated />
        <IonSkeletonText className='presentation' animated />
        <div className='contact-wrapper'>
          <IonSkeletonText className='button' animated />
          <IonSkeletonText className='button' animated />
          <IonSkeletonText className='button' animated />
          <IonSkeletonText className='button' animated />
          <IonSkeletonText className='button' animated />
          <IonSkeletonText className='button' animated />
        </div>
      </div>
    </section>
  )
}

export default EditorCard
